/**
 * Route for `openapi-spec-sdks-node-python-go-php-ruby`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OpenapiSpecSdksNodePythonGoPhpRubyPage } from "../features/openapi-spec-sdks-node-python-go-php-ruby/OpenapiSpecSdksNodePythonGoPhpRubyPage";

export const openapiSpecSdksNodePythonGoPhpRubyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/openapi-spec-sdks-node-python-go-php-ruby",
	component: OpenapiSpecSdksNodePythonGoPhpRubyPage,
});

export default openapiSpecSdksNodePythonGoPhpRubyRoute;
